import { all, call, SagaReturnType, takeLatest } from "redux-saga/effects";

import {
  createDistributionAction,
  editDistributionAction,
  loadDistributionsAction,
} from "store/distribution/distribution.actions";
import { loadDistributions, createDistribution, editDistribution } from "api/distribution";

function* loadDistributionsFlow(action: typeof loadDistributionsAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof loadDistributions> = yield call(loadDistributions, action.payload)
    yield call(loadDistributionsAction.sagas.resolve, action, {
      items: data['hydra:member'],
      total: data['hydra:totalItems'],
    })
  } catch (e: any) {
    yield call(loadDistributionsAction.sagas.reject, action, e?.message)
  }
}

function* createDistributionFlow(action: typeof createDistributionAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof createDistribution> = yield call(createDistribution, action.payload);
    yield call(createDistributionAction.sagas.resolve, action, data);
  } catch (e: any) {
    yield call(createDistributionAction.sagas.reject, action, e?.response?.data || e);
  }
}

function* editDistributionFlow(action: typeof editDistributionAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof editDistribution> = yield call(editDistribution, action.payload);
    yield call(editDistributionAction.sagas.resolve, action, data);
  } catch (e: any) {
    yield call(editDistributionAction.sagas.reject, action, e?.response?.data || e);
  }
}

export default function* administrationSaga() {
  yield all([
    takeLatest(loadDistributionsAction.trigger, loadDistributionsFlow),
    takeLatest(createDistributionAction.trigger, createDistributionFlow),
    takeLatest(editDistributionAction.trigger, editDistributionFlow),
  ]);
}